import { getLogger, httpClientInterface } from 'app-components/utils/core';
import { getServiceUrl } from 'app-components/utils/core/interfaces/httpClientInterface';

import {
  type Biller,
  type BillerAccount,
  type EnrollResponse,
  type SearchResponse,
  type SubmitRequest,
  type ValidateRequest,
  type ValidateResponse,
} from './billPresentmentTypes';

const log = getLogger('flux/bill-presentment/api.ts');

export default {
  async search(query: string) {
    const requestUrl = `${getServiceUrl()}/malipo-biller-directory/api/v2/biller/search`;
    const response = await httpClientInterface.send('POST', requestUrl, { intent: 'PRESENTMENT', billerName: query });
    log.debug('biller searchResponse', response?.data);
    return response?.data as SearchResponse;
  },
  async getPopularBillers() {
    const requestUrl = `${getServiceUrl()}/malipo-biller-directory/api/v1/biller/intent/PRESENTMENT/popular`;
    const response = (await httpClientInterface.send<{ data: Biller[] }, any, any>(
      'GET',
      requestUrl,
      undefined,
      undefined,
      {
        limit: 50,
      },
    )) as {
      data: { data: Biller[] };
    };

    const filteredBillers = response?.data?.data?.filter((datum) => datum.mode === 'PARTNER') || [];
    log.debug('biller getPopularBillersResponse filtered', filteredBillers);
    return filteredBillers;
  },
  async getEnrollment(id: string) {
    const requestUrl = `${getServiceUrl()}/malipo-biller-directory/api/v1/biller/${id}/enrollment`;
    const response = await httpClientInterface.send('GET', requestUrl);
    log.debug('biller enrollResponse', response?.data);
    return response?.data as EnrollResponse;
  },
  async validate(id: string, payload: ValidateRequest) {
    const requestUrl = `${getServiceUrl()}/malipo-biller-directory/api/v1/biller/${id}/enrollment/validate`;
    const response = await httpClientInterface.send('POST', requestUrl, payload);
    log.debug('billerAccount validateResponse', response?.data);
    return response?.data as ValidateResponse;
  },
  async submit(payload: SubmitRequest) {
    const requestUrl = `${getServiceUrl()}/aikya-presentment/api/v1/biller-account/submit`;
    const response = await httpClientInterface.send('POST', requestUrl, payload);
    log.debug('billerAccount submitResponse', response?.data);
    return response?.data as BillerAccount;
  },
  async confirm(id: string) {
    const requestUrl = `${getServiceUrl()}/aikya-presentment/api/v1/biller-account/${id}/confirm`;
    const response = await httpClientInterface.send('PUT', requestUrl);
    log.debug('billerAccount confirmResponse', response?.data);
    return response?.data as BillerAccount;
  },

  async fetch() {
    const requestUrl = `${getServiceUrl()}/aikya-presentment/api/v1/biller-account`;
    const response = (await httpClientInterface.send<{ data: BillerAccount[] }, any, any>('GET', requestUrl)) as {
      data: { data: BillerAccount[] };
    };
    log.debug('billerAccount fetch Response', response?.data);
    return response?.data?.data; // ugly but I didn't make the APIs
  },
  async delete(id: string) {
    const requestUrl = `${getServiceUrl()}/aikya-presentment/api/v1/biller-account/${id}`;
    await httpClientInterface.send('DELETE', requestUrl);
  },

  async getBiller(id: string) {
    const requestUrl = `${getServiceUrl()}/malipo-biller-directory/api/v2/biller/${id}`;
    const response = await httpClientInterface.send('GET', requestUrl);
    return response?.data as Biller;
  },
} as const;
